import { PackagesModel } from './packages.model';

export class AssortmentRxModel {
  quota: PackagesModel | null = null;
  quota_high_price: PackagesModel | null = null;
  tfg: PackagesModel | null = null;
  tfg_high_price: PackagesModel | null = null;
  stock_item: PackagesModel | null = null;
  order_types: PackagesModel | null = null;
  order_types_high_price: PackagesModel | null = null;
  rx_below_order_value: PackagesModel | null = null;
  hemophilia: PackagesModel | null = null;
  hemophilia_high_price: PackagesModel | null = null;
  dg_pharma_mall: PackagesModel | null = null;
  dg_pharma_mall_high_price: PackagesModel | null = null;
  sums: PackagesModel | null = null;
  visible = false;

  readonly sort = [
    'quota', 'quota_high_price', 'tfg', 'tfg_high_price',
    'stock_item', 'order_types', 'order_types_high_price',
    'rx_below_order_value', 'hemophilia', 'hemophilia_high_price',
    'dg_pharma_mall', 'dg_pharma_mall_high_price'
  ] as const;

  private readonly labelMap: Record<string, string> = {
    quota: 'Kontingent',
    quota_high_price: 'Kontingent Hochpreis',
    tfg: 'TFG',
    tfg_high_price: 'TFG Hochpreis',
    stock_item: 'Lagerartikel',
    order_types: 'Auftragsarten',
    order_types_high_price: 'Auftragsarten Hochpreis',
    rx_below_order_value: 'RX unter Auftragswert',
    hemophilia: 'Hämophilie',
    hemophilia_high_price: 'Hämophilie Hochpreis',
    dg_pharma_mall: 'DG Pharma Mall',
    dg_pharma_mall_high_price: 'DG Pharma Mall Hochpreis'
  };

  constructor(obj?: Record<string, any>) {
    if (!obj) return;

    for (const [key, label] of Object.entries(this.labelMap)) {
      if (obj[key]) {
        obj[key].label = label;
        (this as any)[key] = new PackagesModel(obj[key]);
      }
    }

    if (obj['sums']) this.sums = new PackagesModel(obj['sums']);
    this.visible = obj['visible'] ?? false;
  }
}

export class AssortmentNonRxModel {
  quota: PackagesModel | null = null;
  special_item: PackagesModel | null = null;
  private_range: PackagesModel | null = null;
  pzn_fees: PackagesModel | null = null;
  stock_item: PackagesModel | null = null;
  special_range: PackagesModel | null = null;
  order_types: PackagesModel | null = null;
  below_order_value: PackagesModel | null = null;
  livsane: PackagesModel | null = null;
  sums: PackagesModel | null = null;
  visible = false;

  readonly sort = [
    'quota', 'special_item', 'private_range', 'pzn_fees',
    'stock_item', 'special_range', 'order_types', 'below_order_value', 'livsane'
  ] as const;

  private readonly labelMap: Record<string, string> = {
    quota: 'Kontingent',
    special_item: 'Spezialartikel',
    private_range: 'Privatsortiment (inkl. Prisma)',
    pzn_fees: 'Gebühren PZN',
    stock_item: 'Lagerartikel',
    special_range: 'Sondersortiment',
    order_types: 'Auftragsarten',
    below_order_value: 'unter Auftragswert',
    livsane: 'LIVSANE Umsatz'
  };

  constructor(obj?: Record<string, any>) {
    if (!obj) return;

    for (const [key, label] of Object.entries(this.labelMap)) {
      if (obj[key]) {
        obj[key].label = label;
        (this as any)[key] = new PackagesModel(obj[key]);
      }
    }

    if (obj['sums']) this.sums = new PackagesModel(obj['sums']);
    this.visible = obj['visible'] ?? false;
  }
}
